import React, { useEffect, useState } from 'react'
import { ExportStatus } from '../../helpers/excelHelper'
import { t } from '../../i18n/i18n'
import { Modal } from '../../components/common/modal/Modal'
import { makeStyles, Spinner } from '@fluentui/react-components'

const useStyles = makeStyles({
   dialog: {
      minHeight: '100px',
   },
})

type DialogExportList = {
   exportingStatus: ExportStatus
}
export const DialogExportingList = ({ exportingStatus }: DialogExportList) => {
   const classes = useStyles()
   const [message, setMessage] = useState<string>(t('PreparingExcel'))

   useEffect(() => {
      if (exportingStatus !== null) {
         const interval = setInterval(() => {
            setMessage((prevMessage) =>
               prevMessage === t('PreparingExcel')
                  ? exportingStatus === ExportStatus.FETCHING_DEMANDS
                     ? t('FetchingDemands')
                     : exportingStatus === ExportStatus.FETCHING_QUESTIONS
                     ? t('FetchingQuestions')
                     : exportingStatus === ExportStatus.GENERATING_EXCEL
                     ? t('GeneratingExcel')
                     : ''
                  : t('PreparingExcel')
            )
         }, 3000)
         return () => clearInterval(interval)
      }
   }, [exportingStatus])

   return (
      <Modal open={exportingStatus !== null} title={t('ExportingDemandsAndQuestions')} contentClassname={classes.dialog}>
         <>
            {message}...
            <Spinner />
         </>
      </Modal>
   )
}
